import { AppointmentIcon } from '@docpace/shared-react-icons'
import { keys, map, includes, isArray } from 'lodash'
const emptyParams: any = {}

export class PartialRoute<T extends { [key: string]: string }> {
    constructor(public readonly path: string, public readonly icon?: any) {
        this.path = path
        this.icon = icon
    }

    href(query: T = emptyParams): { pathname: string; query: T } {
        return {
            pathname: this.path,
            query,
        }
    }

    hrefNext(query: T = emptyParams): string {
        let nextQuery = {}
        let nextPathname = this.path
        map(query, (val: any, key)=>{
            let keyPath = `[${key}]`
            if(includes(nextPathname, keyPath)){
                nextPathname = nextPathname.replace(keyPath, isArray(val) ? val?.join(',') : val)
            } else {
                nextQuery[keyPath.substring(1, keyPath?.length - 1)] = val
            }
        })
        return nextPathname + (keys(nextQuery).length > 0 ? `?` + new URLSearchParams(nextQuery) : '')
    }
}

const receptionStatusRoutes = Object.freeze({
    ForgotPassword: new PartialRoute('/auth/forgot'),
    ResetPassword: new PartialRoute('/auth/reset'),
    Signin: new PartialRoute('/auth'),
    AdminSignin: new PartialRoute('/auth/admin'),
    Signout: new PartialRoute('/api/auth/signoutManager'),
    Index: new PartialRoute('/', AppointmentIcon),
})

export default receptionStatusRoutes
